import React, { useCallback } from 'react';

import Range from './Range';
import isObject from '../../util/isObject';
import useGlobals from '../../hooks/useGlobals';
import ColorPicker from './ColorPicker/ColorPicker';
import Label from '../setting-components/Label/Label';

const regx = /(--color-\d+)/gi;

function SimpleBorder(props) {
    const { value, onChange, name } = props;
    // TODO: issue fix: split by space for rgba color
    let [width = '', style = 'solid', color = ''] = value
        ? value.split(' ')
        : [];

    let selectedColor = color;
    const { colors } = useGlobals();
    const isGlobalColor = regx.test(color);
    if (isGlobalColor) {
        selectedColor = colors.find((col) => col.key === color.match(regx)[0]);
    }

    const handleRange = useCallback(
        ({ value }) => {
            onChange({ name, value: `${value} ${style} ${color}` });
        },
        [onChange, name, style, color]
    );

    const handleColorChange = useCallback(
        ({ value }) => {
            value = isObject(value) ? `var(${value.key})` : value;
            onChange({ name, value: `${width} ${style} ${value}` });
        },
        [name, onChange, style, width]
    );

    return (
        <div>
            <Label style={{ marginTop: 20 }}>Border Width</Label>
            <Range defaultUnit="px" value={width} onChange={handleRange} />
            <Label style={{ marginTop: 20 }}>Border Color</Label>
            <ColorPicker value={selectedColor} onChange={handleColorChange} />
        </div>
    );
}

export default SimpleBorder;
